import { getLatestContract } from "@/services/core-api-adapter";
import { useQuery } from "@tanstack/react-query";

export default function useGetLatestContract(quoteId: string | null) {
  const { data, error, isError, isPending, isLoading } = useQuery({
    queryKey: ["getLatestContract", quoteId],
    queryFn: async () => {
      if (!quoteId) throw new Error("quoteId is required");
      return getLatestContract(quoteId);
    },
    enabled: !!quoteId,
  });

  return {
    data,
    error,
    isError,
    isPending,
    isLoading,
  };
}
